import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { COLLECTION_DESCRIPTION_MAX_LENGTH } from '../../content/contentDetailDialog/DescriptionDetailSection';
import { InlineEditableDescription,InlineEditableDescriptionProps } from '../Header/InlineEditableDescription';
import { UpdateCollectionsResponseData } from './CollectionModels';
import { CollectionSpaceHeaderProps } from './CollectionSpaceHeader';
import { CollectionsResourceQuery, UpdateCollectionData } from './ResourceQuery/CollectionsResourceQuery';

export interface EditableCollectionDescriptionInlineProps extends CollectionSpaceHeaderProps {
  readonly canEdit: boolean;
  readonly onEditChange: (isEditing: boolean) => void;
}

export function EditableCollectionDescriptionInline(props: EditableCollectionDescriptionInlineProps): JSX.Element {
  const updateDescription = React.useCallback(
    async (description: string): Promise<void> => {
      const updatedCollectionData: UpdateCollectionData = {
        luid: props.item.luid,
        description: description
      };
      const response: UpdateCollectionsResponseData = await (new CollectionsResourceQuery()).update([updatedCollectionData]);
      if (response.errors && response.errors.length > 0) {
        throw {
          data: [{errorCode: response.errors[0].errorCode}]
        };
      }
      props.reloadSpace();
    },
    // This deps array was noncompliant before we enabled the lint rule. If you’re here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.item.luid]
  );


  const descriptionProps: InlineEditableDescriptionProps = {
    ...props,
    maxCharacterCount: COLLECTION_DESCRIPTION_MAX_LENGTH,
    updateDescription: updateDescription,
    sanitizer: props.sanitizer,
    canEdit: props.isAdminOrOwner && props.canEdit,
    onEditChange: props.onEditChange,
    ariaLabel: Messages.collectionDescriptionTextAreaLabel(),
  };

  return <InlineEditableDescription {...descriptionProps} />;
}
